module.exports = __webpack_public_path__ + "img/isric.9115b0d9.svg";